import PropTypes from 'prop-types';
import Image from '@plone/volto/components/theme/Image/Image';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';

import { homepageImageSources } from '../../../helpers/homepageUtils';

const isExternalHref = (href) =>
  href?.startsWith('http://') || href?.startsWith('https://');

const HomepageIconsBody = ({ icons = [], editPreview = false }) => {
  if (!icons.length) return null;

  return (
    <div className="rectified-icons-container">
      {icons.map((icon, index) => {
        const sources = homepageImageSources(icon.image, {
          minWidth: 64,
          fallback: 'thumb',
        });
        const content = (
          <>
            {sources.src ? (
              <Image
                className="rectified-icon-image"
                alt={icon.title || ''}
                sizes="64px"
                loading="lazy"
                src={sources.src}
                srcSet={sources.srcSet}
                width={64}
                height={64}
              />
            ) : null}
            <span className="rectified-icon-text">{icon.title}</span>
          </>
        );

        if (editPreview || !icon.link) {
          return (
            <div
              key={icon['@id'] || index}
              className={`rectified-icon${index === 0 ? ' first' : ''}`}
            >
              {content}
            </div>
          );
        }

        return (
          <UniversalLink
            key={icon['@id'] || index}
            href={icon.link}
            openLinkInNewTab={isExternalHref(icon.link)}
            className={`rectified-icon${index === 0 ? ' first' : ''}`}
          >
            {content}
          </UniversalLink>
        );
      })}
    </div>
  );
};

HomepageIconsBody.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.object),
  editPreview: PropTypes.bool,
};

const View = ({ data, className }) => (
  <div className={className}>
    <HomepageIconsBody icons={data.icons} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  className: PropTypes.string,
};

export default withBlockExtensions(View);
export { HomepageIconsBody };
